import React, { useState, useEffect } from "react";
import {
	TextField,
	Grid,
	MenuItem,
	Button,
	Dialog,
	DialogActions,
	DialogContent
} from "@mui/material";
import { Card } from "reactstrap";
import Layout from "../../components/Wrappers/Layout";

import CustomButton from "../../../src/components/CustomButton/CustomButton";
import { AiOutlineSearch } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";
import {
	resetAddNewWalletForCustomerList,
	addNewWalletForCustomerList
} from "../../redux/actions/addNewWalletForCustomerAction";

import {
	resetGetCustomerIdAndNameList,
	getCustomerIdAndNameList
} from "../../redux/actions/getCustomerIdAndNameListAction";
import Autocomplete from "@mui/lab/Autocomplete";
import { createFilterOptions } from "@mui/material";
// import Autocomplete from '@mui/material/lab/Autocomplete';
// import Autocomplete, {
// 	createFilterOptions
// } from "@mui/material/lab/Autocomplete";

import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import BackButton from "../../components/BackButton/BackButton";

import { getStoreList } from "../../redux/actions/getStoreListAction";
import SOLogout from "../../components/Logout/SOLogout";
import Util from "../../validation";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";

//new
import {
	getRegenerateToken,
	resetRegenerateToken,
} from "../../redux/actions/regenerateTokenAction";


function AddNewCustomerWallet() {
	const [customerOrmerchantId, setcustomerOrmerchantId] = useState("");
	const [customerOrmerchantName, setcustomerOrmerchantName] = useState("");
	const [walletName, setWalletName] = useState("");
	const [currency, setcurrency] = useState("");
	const [store, setStore] = useState("");
	const [addNewWalletForCustomerResArray, setaddNewWalletForCustomerResArray] =
		useState("");
	const [notificationOpen, setNotificationOpen] = React.useState(false);

	const [addNewWalletForCustomer, setaddNewWalletForCustomer] =
		React.useState(false);

	const dispatch = useDispatch();
	// const partnerloginUser = useSelector(({ login }) => login);
	// var authToken = partnerloginUser.data.AuthToken;

	// const regenerateTokenRes = useSelector(
	// 	({ regenerateToken }) => regenerateToken
	// );
	// //console.log("regenerateTokenRes", regenerateTokenRes);
	// var authToken = regenerateTokenRes.data.AuthToken;




	const regenerateTokenRes = useSelector(({ regenerateToken }) => regenerateToken);
	var authToken = regenerateTokenRes.data.AuthToken;

	const handleChange = ({ target: { name, value } }) => {
		if (name === "customerOrmerchantId") {
			setcustomerOrmerchantId(value);
			getStoreData(value.split("-")[0]);
		}

		if (name === "customerOrmerchantName") {
			setcustomerOrmerchantName(value);
		}

		if (name === "currency") {
			// setcurrency(value);
			setcurrency(value == "Select Currency" ? "" : value);
		}
		if (name === "store") {
			setStore(value == "Select Store" ? "" : value);
		}
		if (name === "walletName") {
			// setWalletName(value);
			Util.verifyAlphabet(value)
				? setWalletName(value)
				: setWalletName(walletName);
		}
	};

	const getCustomerIdAndNameListRes = useSelector(
		({ getCustomerIdAndNameList }) => getCustomerIdAndNameList
	);

	const adminCurrencyLists = useSelector(
		({ adminCurrencyList }) => adminCurrencyList
	);

	const addNewWalletForCustomerRes = useSelector(
		({ addNewWalletForCustomer }) => addNewWalletForCustomer
	);

	const getStoreLists = useSelector(({ getStoreList }) => getStoreList);

	// console.log("addNewWalletForCustomerRes" + addNewWalletForCustomerRes);

	const addNewWalletForCustomerApi = (id) => {
		setaddNewWalletForCustomer(true);
		const getAllWalletsListReq = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			},
			actionCustomerMasterRequestVO: {
				// customerId: customerOrmerchantId.split("-")[0],
				// customerName: customerOrmerchantName,
				// currency: currency,
				customerId: customerOrmerchantId.split("-")[0],
				storeId: store.split("-")[0],
				walletType: "",
				currency: currency,
				walletName: walletName
			}
		};

		return dispatch(
			addNewWalletForCustomerList(getAllWalletsListReq, authToken)
		);
	};

	const handleNoticationClose = () => {
		setNotificationOpen(false);
	};

	const addNewWalletForCustomerFunc = () => {
		if (addNewWalletForCustomer) {
			if (addNewWalletForCustomerRes.data.status == "success") {
				setNotificationOpen(true);
				setaddNewWalletForCustomerResArray(
					addNewWalletForCustomerRes.data.status
				);
			}
			if (addNewWalletForCustomerRes.data.status == "failed") {
				setNotificationOpen(true);
				setaddNewWalletForCustomerResArray(addNewWalletForCustomerRes.data);
				if (
					addNewWalletForCustomerRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					addNewWalletForCustomerRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}

			if (addNewWalletForCustomerRes.data.status == "Failed") {
				setNotificationOpen(true);
				setaddNewWalletForCustomerResArray(addNewWalletForCustomerRes.data);
				if (
					addNewWalletForCustomerRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					addNewWalletForCustomerRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (addNewWalletForCustomerRes.data.errorList) {
				setNotificationOpen(true);
				setaddNewWalletForCustomerResArray(addNewWalletForCustomerRes);
			}
		}
	};

	// const filterOptions = createFilterOptions({
	// 	matchFrom: "any",
	// 	limit: 500
	// });
	const filterOptions = (options, { inputValue }) => {
		if (inputValue.length < 3) {
			return [];
		}

		const filterOptionsList = options.filter(
			(option) =>
				option.includes(inputValue) ||
				""
		);

		return filterOptionsList.slice(0, 20);
	}


	useEffect(() => {
		addNewWalletForCustomerFunc();
	}, [addNewWalletForCustomerRes.data.status]);

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			const getCustomerIdAndNameReq = {
				loginDetails: {
					walletOwnerId: regenerateTokenRes.data.partnerId || ""
				},
				actionCustomerMasterRequestVO: {
					customerNameOrId: ""
				}
			};

			dispatch(getCustomerIdAndNameList(getCustomerIdAndNameReq, authToken));
		}
	}, [regenerateTokenRes.data.status]);

	const getStoreListApi = (id) => {
		const req = {
			authentication: {
				partnerId: regenerateTokenRes.data.partnerId || ""
			},
			customerRequestVo: {
				customerID: id
			}
		};
		dispatch(getStoreList(req, authToken));
	};

	const getStoreData = (id) => {
		getStoreListApi(id);
	};

	return (
		<>
			<Layout>
				<BackButton />
				<Card>
					{/* <BackButton /> */}
					<Grid item xs={12} md={0} lg={0}></Grid>
					<Grid
						container
						spacing={2}
						style={{ padding: "25px", marginTop: "2rem" }}
					>
						<Grid item xs={12} sm={12} md={3} lg={3}>
							<Autocomplete
								id="combo-box-demo"
								options={[].concat(
									getCustomerIdAndNameListRes.data.currencyList || [""]
								)}
								getOptionLabel={(option) => option}
								filterOptions={filterOptions}
								renderInput={(params) => (
									<TextField
										autoFocus
										margin="dense"
										id="name"
										label="Customer/Merchant ID"
										required
										type="text"
										fullWidth
										{...params}
										value={customerOrmerchantId || ""}
										name="customerOrmerchantId"
										onBlur={handleChange}
										variant="standard"
										sx={{
											"& .MuiInput-underline:before": {
											  borderBottomColor: "gray", // White color for the underline before focus
											},
											"& .MuiInput-underline:hover:not(.Mui-disabled):before": {
											  borderBottomColor: "gray", // White color on hover
											},
											"& .MuiInput-underline:after": {
											  borderBottomColor: "gray", // White color after focus
											},
										  }}
									/>
								)}
							/>
						</Grid>
						<Grid item xs={12} sm={12} md={3} lg={3}>
							<TextField
								select
								required
								autoFocus
								margin="dense"
								id="name"
								label="Store"
								fullWidth
								variant="standard"
								type="text"
								name="store"
								// value={currency || ""}
								defaultValue={"Select Store" || store}
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="Select Store" selected="Select Store">
									Select Store
								</MenuItem>
								{getStoreLists.success &&
									[]
										.concat(getStoreLists.data.currencyList)
										.map((x) => <MenuItem value={x}>{x}</MenuItem>)}
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={3} lg={3}>
							<TextField
								select
								required
								autoFocus
								margin="dense"
								id="name"
								label="Currency"
								fullWidth
								variant="standard"
								type="text"
								name="currency"
								// value={currency || ""}
								defaultValue={"Select Currency" || currency}
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="Select Currency" selected="Select Currency">
									Select Currency
								</MenuItem>
								{adminCurrencyLists.success &&
									[]
										.concat(adminCurrencyLists.data.currencyList)
										.map((x) => <MenuItem value={x}>{x}</MenuItem>)}
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={3} lg={3}>
							<TextField
								autoFocus
								margin="dense"
								id="name"
								label="Wallet Name"
								type="text"
								fullWidth
								variant="standard"
								name="walletName"
								value={walletName || ""}
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							/>
						</Grid>
						<Grid
							item
							xs={12}
							sm={12}
							md={2}
							lg={2}
							container
							style={{
								padding: "10px",
								marginTop: "0.5rem",
								marginBottom: "15px"
							}}
						>
							<Grid>
								{/* <Button
                  style={{
                    marginLeft: "0.7rem",
                    backgroundColor: "#00b9f5",
                    color: "white",
                  }}
                  variant="contained"
                  onClick={addNewWalletForCustomerApi}
                >
                  Add Wallet
                </Button> */}
								<CustomButton
									style={{
										padding: "8px"
									}}
									onClick={addNewWalletForCustomerApi}
								>
									Add Wallet
								</CustomButton>
							</Grid>
						</Grid>
					</Grid>
				</Card>{" "}
			</Layout>

			{addNewWalletForCustomerResArray == "success" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent className="text-center"
						style={{ backgroundColor: "#00b9f51c" }}
						
						>
							<img src={success} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h3
								style={{
									margin: "0 20px",
									fontSize: "15px",
									textAlign: "center"
								}}
							>
								Wallet Created Successfully
							</h3>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<CustomButton
								style={{
									padding: "8px 16px"
								}}
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{addNewWalletForCustomerResArray.status == "failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent className="text-center"
						style={{ backgroundColor: "#00b9f51c" }}
						
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h3
								style={{
									margin: "0 20px",
									fontSize: "15px",
									textAlign: "center"
								}}
							>
								{/* Wallet Creation Failed */}
								{addNewWalletForCustomerResArray.description}
							</h3>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<CustomButton
								style={{
									padding: "8px 16px"
								}}
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{addNewWalletForCustomerResArray.status == "Failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent className="text-center"
						style={{ backgroundColor: "#00b9f51c" }}
						
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h3
								style={{
									margin: "0 20px",
									fontSize: "15px",
									textAlign: "center"
								}}
							>
								{/* Wallet Creation Failed */}
								{addNewWalletForCustomerResArray.description}
							</h3>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<CustomButton
								style={{
									padding: "8px 16px"
								}}
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}
		</>
	);
}

export default AddNewCustomerWallet;
